module.exports = __webpack_public_path__ + "img/CustomFields-4.cd85b19d.png";